import React, { useState } from "react";
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { Form, Button } from 'react-bootstrap';

import DateSelector from './DateSelector';

const SensorList = ({
  data, 
  t_graph_update_graph_selectedDate_by_devId_and_sensorId, 
  t_graph_update_graph_field_prop_by_devId_and_sensorId,
  t_update_request_graph_by_devId_and_sensorId,
  t_update_request_graph_by_devId_and_sensorId2,
  t_update_request_graph_rx_data
}) => {
  
  if (data === undefined) return null;
  if (!data[0].sensors.length) return null;
  //console.log(data)
  //Empty value test
  if (Object.keys(data).length === 0) return null

  const lastValues1 = (sensor_data, min_ago) => {
    //console.log(sensor_data)
    if (min_ago > 60) return <p className="card-text text-warning">No actual data... </p>
    const valuesArray = []
    sensor_data.map((o,k) => {
        valuesArray.push (
                o.card_prefix + o.last_value + o.card_suffix
            )
        })
    return <p className="card-text text-info">{valuesArray.join("; ")} </p>
  }
  const lastValues = (sensor_data, min_ago, dev_id, sensor_id) => {
    //console.log(sensor_data, dev_id, sensor_id)
    if (min_ago > 60) return <p className="card-text text-warning">No actual data... </p>
    const valuesArray = []
    const out = sensor_data.map((o,k) => {
        //console.log('show? ', o.form_sensor_field_ignore)
/*         let block = (k === 0) 
         ? <span className="">{o.card_prefix + o.last_value + o.card_suffix}</span> 
         : <span className="">; {o.card_prefix + o.last_value + o.card_suffix}</span> */

        return <div key={('block_'+k)}
               className={`${o.form_sensor_field_ignore? "border text-muted" : "border border-primary"} m-1 p-1`}
              /*  style={{cursor: 'pointer'}} */
               onClick={()=>{
                //console.log(dev_id, sensor_id, o.db_field)
                //t_graph_update_graph_field_prop_by_devId_and_sensorId(dev_id, sensor_id, o.db_field)
               }}
               >{o.card_prefix}<span className={`${o.form_sensor_field_ignore? "font-weight-bold text-secondary" : "font-weight-bold text-primary"}`}>{o.last_value}</span>{o.card_suffix}</div>
        })
    return <div className="d-flex">{out}</div>;
  }//font-weight-bold text-primary
  const onlineDecor = (online_state) => {
    if (online_state === 1) return "text-info"
    if (online_state === 0) return "text-danger"
    if (online_state === null) return "text-warning"
  }

  return (
    <>
    <div className="container mt-1">
    <h4 className="text-info" >Sensor List</h4>
    {
        data.map((dev,i) => {
          //console.log(dev)
            return (
                dev.sensors.map((sens, m)=> {
                  //console.log(sens)
                  return (
                    <div className="border border-info rounded p-2 m-2" key={`sens_${m}`}>
                    <div className="d-flex flex-row justify-content-between flex-wrap">

                    <p className="">
                      <span className={onlineDecor(dev.online_state)}><strong>Dev #</strong>{`${dev.id}`} </span>; 
                      <span className="ml-2 text-secondary"><strong>Sensor #</strong>{sens.sensor_id};</span>
                      <span className="ml-2 text-secondary"><strong>Name: </strong>{sens.name};</span>
                      <span className="ml-2 text-secondary"><strong>min ago:</strong> {`${sens.min_ago}; `} </span>
                      <span className="ml-2">{`<`}
                        <Link to={`/selected_device/${dev.id}`}>dev details...</Link>
                        {`>`}
                      </span>
                    </p>
                    <DateSelector 
                    data = {data}
                    dateList={sens.date_list}
                    card_sensor_data = {sens.card_sensor_data}
                    form_graph_selected_date = {sens.form_graph_selected_date}
                    t_graph_update_graph_selectedDate_by_devId_and_sensorId={t_graph_update_graph_selectedDate_by_devId_and_sensorId}
                    dev_id={dev.id}
                    sensor_id={sens.sensor_id}
                    t_update_request_graph_by_devId_and_sensorId2 = {t_update_request_graph_by_devId_and_sensorId2}
                    t_update_request_graph_rx_data = {t_update_request_graph_rx_data}
                    />

                    </div>


                    {lastValues(sens.card_sensor_data, sens.min_ago, dev.id, sens.sensor_id)}
                    
                    
                </div>
                  )
                })
            )
        })
    }
</div>


  
    </>
  )
}

export default SensorList
